(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
   function eventHandler() {
    var inputBox = document.querySelectorAll('.t-4-search-box input');
    inputBox.forEach(function(item) {
        item.addEventListener("focus", function() {
            item.blur();
            setTimeout(function() {
                document.querySelector(".site-nav__icons > a[href='/search']").click();
            }, 300);
        })
    })

    var svg_click = document.querySelectorAll('.t-4-search-box svg')
    svg_click.forEach(function(item) {
        item.addEventListener("click", function() {
            setTimeout(function() {
                document.querySelector(".site-nav__icons > a[href='/search']").click();
            }, 300);
        })
    })
}

eventHandler();
if (window.innerWidth <= 1024) {
    document.querySelector("body").classList.add("t-4-homepage-mobile")
    eventHandler();

}

 function live(selector, event, callback, context) {
    /****Helper Functions****/
    // helper for enabling IE 8 event bindings
    function addEvent(el, type, handler) {
      if (el.attachEvent) el.attachEvent('on' + type, handler);
      else el.addEventListener(type, handler);
    }
    // live binding helper using matchesSelector
    function live(selector, event, callback, context) {
      addEvent(context || document, event, (e) => {
        let found,
          el = e.target || e.srcElement;
        while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
        if (found) callback.call(el, e);
      });
    }
    live(selector, event, callback, context);
  }


     function bmScroll(bmContentId, bmValue) {
      const bmContent = document.querySelector(bmContentId);
      const scrollTop = bmContent.getBoundingClientRect().top + window.pageYOffset - bmValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    }


    live(".About-us", "click", function () {
        setTimeout(function () {
          if (document.querySelector(" .About-us .collapsible-trigger").classList.contains("is-open")) {
            var objDiv = document.querySelector(".drawer__scrollable");
            objDiv.scrollTop = objDiv.scrollHeight;
          }
        }, 600);
      });
    


  

  } catch(e) { console.error(e); }
})();
})();
